/**
 * De volgorde waarin een onderzoeker zijn werk wil zien.
 *
 * Eerst de onderzoeken die lópen maar stilgevallen zijn, langst stil bovenaan
 * (op het exacte tijdstip van het laatste antwoord, niet op hele dagen):
 * daar is een meting begonnen en niet afgemaakt, en dat is het gat waar straks
 * geen ontwikkeling uit te laten zien is.
 *
 * Daaronder de onderzoeken waar nog nooit iets binnenkwam, op titel. Die hebben
 * geen stilteduur, dus ze kunnen niet meedoen in die volgorde — en bovenaan
 * zetten zou ze vóór een meting laten komen waarvan we wél weten hoe lang hij
 * stilligt. Een onbekende duur is geen oneindige duur.
 * AI-CONTEXT: See docs/pitfalls.md#ui-display-fallback-used-as-sort-key
 *
 * @param {Array<import('./buildAnonymousResearchRows').AnonymousResearchRow>} [rows]
 * @returns {Array<import('./buildAnonymousResearchRows').AnonymousResearchRow>}
 */
const selectAnonymousResearch = (rows) => (rows || [])
    .filter(Boolean)
    .sort((a, b) => {
        const aKnown = typeof a.silentSinceMs === 'number'
        const bKnown = typeof b.silentSinceMs === 'number'
        if (aKnown !== bKnown) return aKnown ? -1 : 1
        // Op milliseconden, niet op hele dagen: twee onderzoeken die even veel
        // DAGEN stil zijn maken gelijkspel, en dan valt `sort` terug op de
        // invoervolgorde — die van Firestore komt en per snapshot wisselt.
        // AI-CONTEXT: See docs/pitfalls.md#database-coarse-sort-key-ties-break-arbitrarily
        if (aKnown) return a.silentSinceMs - b.silentSinceMs
        return (a.researchTitle || '').localeCompare(b.researchTitle || '', 'nl')
    })

export default selectAnonymousResearch
